import { TermType } from "@/views/Price/types";
import { PlanStatus } from "../../types/plan";

export function getPlanDateUnit(date: TermType): string {
	switch (date) {
		case "Y": {
			return "년";
		}
		case "M": {
			return "월";
		}
		case "D": {
			return "일";
		}
	}
}

export function getPlanStatusText(type: PlanStatus) {
	switch (type) {
		case "0": {
			return "등록";
		}

		case "1": {
			return "완료";
		}

		case "99": {
			return "취소";
		}
	}
}

export function getPlanStatusClassName(type: PlanStatus) {
	switch (type) {
		case "0": {
			return "ing";
		}

		case "1": {
			return "ing";
		}

		case "99": {
			return "end";
		}
	}
}
